import {
  GipAltReportDtoTypeEnum,
  GipReportDtoTypeEnum,
} from '@app/modules/audit/modules/global-audit/gip.types';
import { ComponentType } from 'react';
import { GipAltReportDetail } from '../gip/gip-alt-report/view/GipAltReportDetail';
import { GipReportDetail } from '../gip/gip-report/view/GipReportDetails';

export const VIEW_MAP: Record<string, ComponentType<{ report: any }>> = {
  [GipReportDtoTypeEnum.AUDIT_GIP_STATUS]: GipReportDetail,
  [GipAltReportDtoTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT]: GipAltReportDetail,
};
